import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex gap-x-6 items-start w-11/12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_DataWrapper, {
        class: "w-8/12",
        label: _ctx.$t('No. Kargo')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LpInput, {
            modelValue: _ctx.formBooking.cargoNumber,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formBooking.cargoNumber = $event)),
            placeholder: _ctx.$t('Masukan No. kargo'),
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateFormBookingCargoNumber($event))),
            error: !!_ctx.errorMessageAwbDetail,
            "error-caption": _ctx.errorMessageAwbDetail,
            isErrorIconCaption: _ctx.formBooking.isValidAwb,
            isErrorIconInput: false,
            disabled: _ctx.disabledInputAwb
          }, null, 8, ["modelValue", "placeholder", "error", "error-caption", "isErrorIconCaption", "disabled"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_LpButton, {
        onClick: _ctx.onCheckAwb,
        customClass: "px-8 mt-6 py-2.5",
        title: _ctx.$t('Periksa'),
        textColor: "white",
        disabled: _ctx.disabledCheckAwb
      }, null, 8, ["onClick", "title", "disabled"])
    ])
  ]))
}